import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Shared bits for the admin Usage Analytics screens (UsagePage,
 * ProjectUsageDetails). Theme tokens only — no hardcoded colors.
 */

/** SHADOW tag for the JS-verified metric — displayed, not yet billed */
export function ShadowTag() {
  return (
    <Box
      component="span"
      sx={{
        ml: 0.5,
        px: 0.5,
        fontSize: 10,
        fontWeight: 500,
        letterSpacing: 0.4,
        textTransform: 'uppercase',
        color: 'info.main',
        border: 1,
        borderColor: 'info.main',
        borderRadius: 0.5,
        verticalAlign: 'text-top',
      }}
    >
      shadow
    </Box>
  );
}

/** Label with an info tooltip (used in table headers and card labels) */
export function HeaderWithTooltip({ label, tooltip, children }) {
  return (
    <Tooltip title={tooltip} arrow>
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
        {label}
        {children}
        <InfoOutlinedIcon sx={{ fontSize: 14, ml: 0.5, opacity: 0.6 }} />
      </Box>
    </Tooltip>
  );
}
